import { DistrictDto, UpdateDistrictDto, UpdateDistrictListDto } from '@families-link/shared';
import { useGetLinguistLinkDistrictListQuery, useUpdateDistrictMutation } from '../../../store/api/district.api';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useMuiModal } from '../../_core/hooks';
import {
	AttachLinguistLinkDistrictFormModal,
	AttachLinguistLinkDistrictFormModalProps,
} from '../components/attach-district-form/attach-linguist-link-district-form.component';

export function useOpenModalAttachLinguistLinkDistrictFormHook() {
	const { data: districtList } = useGetLinguistLinkDistrictListQuery();

	const [updateDistrict] = useUpdateDistrictMutation();

	const { enqueueSnackbar } = useSnackbar();

	const { openModal, closeModal, updateCurrentModal } = useMuiModal<AttachLinguistLinkDistrictFormModalProps>(
		AttachLinguistLinkDistrictFormModal
	);

	const handleOpenModal = useCallback(
		(district: DistrictDto) => {
			const showToast = (
				message: string,
				variant: 'error' | 'default' | 'success' | 'warning' | 'info' | undefined
			) => {
				enqueueSnackbar(message, {
					variant,
				});
			};

			const handleSubmit = async (values: UpdateDistrictListDto): Promise<void> => {
				try {
					const updateDistrictData: UpdateDistrictListDto = { ...values };
					await updateDistrict({ id: values._id!, data: updateDistrictData }).unwrap();
					showToast('Districts list was successfully attached to survey template', 'success');

					closeModal();
				} catch (error) {
					updateCurrentModal({ formError: error });
					showToast('Districts attaching was failed', 'error');
				}
			};

			openModal({
				districtList,
				defaultValues: district,
				submitAction: handleSubmit,
				closeModal,
			});
		},
		[openModal, closeModal, updateDistrict, updateCurrentModal, enqueueSnackbar, districtList]
	);

	return handleOpenModal;
}
